import React from "react";
export default function TextError(message) {
    return (
        <div className="error_msg">{message || ""}</div>
    )
}